module.exports = __webpack_public_path__ + "static/theBrandsFront-3dad866647a646b1797d84f38f595c89.png";